import React, { createContext, useContext, useMemo, useState } from 'react';

type InsurerHeaderActionsContextValue = {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
};

const InsurerHeaderActionsContext = createContext<InsurerHeaderActionsContextValue | null>(null);

export const InsurerHeaderActionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <InsurerHeaderActionsContext.Provider value={value}>
      {children}
    </InsurerHeaderActionsContext.Provider>
  );
};

export function useInsurerHeaderActions(): InsurerHeaderActionsContextValue {
  const context = useContext(InsurerHeaderActionsContext);
  if (!context) {
    throw new Error('useInsurerHeaderActions must be used within InsurerHeaderActionsProvider');
  }
  return context;
}

export const InsurerHeaderActionsSlot: React.FC = () => {
  const { actions } = useInsurerHeaderActions();
  if (!actions) return null;

  return (
    <div className="ml-4 shrink-0 flex items-center gap-2 flex-wrap justify-end">
      {actions}
    </div>
  );
};
